import React from 'react';
import MainLayout from './MainLayout';
import { Outlet } from 'react-router-dom';

const SystemSettingsLayout: React.FC = () => {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
};

export default SystemSettingsLayout;
